import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { get } from 'axios'

let messages = require('@/i18n/en')

try {

    if (process.env.VUE_APP_ENV !== 'local') {
        const editedMessages = require('@/i18n/en.edited.json')
        messages = Object.assign(messages, editedMessages)
    }

} catch (e) {
    window.console.error(e)
    window.console.info('English edited version not found')
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { 'en': messages }
})

const loadedLanguages = ['en']

function setI18nLanguage(lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang) {

    if (process.env.VUE_APP_LOCALE_ASYNC) {
        const localeFileUrl = `${process.env.VUE_APP_ROOT_URL}i18n/${lang}.json`

        return get(localeFileUrl).then(res => {
            i18n.setLocaleMessage(lang, res.data)
            loadedLanguages.push(lang)

            return setI18nLanguage(lang)
        })
    }

    if (i18n.locale !== lang) {

        let jsonFilename = lang

        if (lang === 'en') {
            jsonFilename = 'en.edited'
        }

        if (!loadedLanguages.includes(lang)) {

            if (process.env.VUE_APP_LOCALE_ASYNC) {
                const localeFileUrl = `${process.env.VUE_APP_ROOT_URL}i18n/${jsonFilename}.json`

                return get(localeFileUrl).then(res => {
                    i18n.setLocaleMessage(lang, res.data)
                    loadedLanguages.push(lang)
                    return setI18nLanguage(lang)
                })
            }

            return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/${jsonFilename}`).then(msgs => {
                i18n.setLocaleMessage(lang, msgs.default)
                loadedLanguages.push(lang)
                return setI18nLanguage(lang)
            }).catch(() => {
                return setI18nLanguage('en')
            })
        }
        return Promise.resolve(setI18nLanguage(lang))
    }

    return Promise.resolve(lang)
}
